import React from 'react';
import Doctors from '../PatientDashboard/Doctors/Doctors';
import Hospitals from './Hospitals/Hospitals';
import SearchDoctors from './SearchDoctors/SearchDoctors';
import Footer from '../Footer/Footer';
const PatientDashBoard = () => {
    return (
        <div>
            <Doctors></Doctors>
            <Hospitals></Hospitals>
            <Footer/>
        </div>
    );
};

export default PatientDashBoard;